import http from '@/utils/http/index';

export function getOperatorList(params) {
  return http.get('/merOperator/listOperator', { params });
}

// 新增操作员
/**
 *
 * @param {
 *  operatorName
 *  operatorEmail
 *  contactEmail
 *  status
 *  roleId
 *  password
 * } data
 * @returns
 */
export function addOperator(data) {
  return http.post('/merOperator/addOperator', data);
}

// 修改操作员
/**
 *
 * @param {
 *  operatorId
 *  operatorName
 *  operatorEmail
 *  contactEmail
 *  status
 *  roleId
 * } data
 * @returns
 */
export function updateOperator(data) {
  return http.post('/merOperator/updateOperator', data);
}

// 重置密码
/**
 *
 * @param {
 *  operatorId
 *  password
 *  loginId
 * } data
 * @returns
 */
export function resetPassword(data) {
  return http.post('/merOperator/updateOperatorLoginPassword', data);
}

export function getPhoneCaptcha(data) {
  return http.post('/merOperator/getPhoneCaptcha', data);
}

export function getOperatorInfo(params = {}) {
  return http.get('/operator/toOperatorInfo', { params });
}
